import axios from '@/axios.js'

export default {
    getResorts: async (params) => {
        const response = await axios.adminapi.get(`v4/resorts`,{
            params: params
        })

        return response.data.object
    },
    getResort: async (uuid) => {
        const response = await axios.adminapi.get(`v4/resorts/${uuid}`)
        return response.data.object
    },
    createResort: async (uuid, data) => {
        const response = await axios.adminapi.post(`v4/resorts/${uuid}`, data)
        return response.data.object
    },

    updateResort: async (uuid, data) => {
        const response = await axios.adminapi.patch(`v4/resorts/${uuid}`, data)
        return response.data.object
    },
    getSnowreportProviders : async (params, page = 1) => {
        const response = await axios.adminapi.get(`v4/snowreport-provider`, { params: {
                ...params,
                page: page
            }
        })
        return response.data.object
    },
    getWeatherProviders : async (params, page = 1) => {
        const response = await axios.adminapi.get(`v4/weather-provider`, { params: {
                ...params,
                page: page
            }
        })
        return response.data.object
    },
    getTouristicObjectProviders : async (params, page = 1) => {
        const response = await axios.adminapi.get(`v4/touristicobjects-provider`, { params: {
                ...params,
                page: page
            }
        })
        return response.data.object
    }

}
